"use client";

import styles from "@/styles/home/quick-menu.module.scss";
import Image from "next/image";
import { Arrow } from "@react-vant/icons";

interface MenuItem {
  title: string;
  href: string;
  image: string;
  description: string;
}

export default function QuickMenu() {
  const MenuList: MenuItem[] = [
    {
      title: "New Arrivals",
      href: "/new-arrivals",
      image: `${process.env.IMAGE_DOMAIN}/home/quick-menu/new-arrivals.svg`,
      description: "New products and show item",
    },
    {
      title: "Free Shipping",
      href: "/free-shipping",
      image: `${process.env.IMAGE_DOMAIN}/home/quick-menu/free-shipping.svg`,
      description: "Free delivery to save money",
    },
    {
      title: "Hot Sellers",
      href: "/hottest-deals",
      image: `${process.env.IMAGE_DOMAIN}/home/quick-menu/hot-sellers.svg`,
      description: "Popular Products & hot sellers",
    },
    {
      title: "Clearance",
      href: "/clearance",
      image: `${process.env.IMAGE_DOMAIN}/home/quick-menu/clearance.svg`,
      description: "Clearance Products",
    },
    {
      title: "Featured Deals",
      href: "/featured-deals",
      image: `${process.env.IMAGE_DOMAIN}/home/quick-menu/featured-deals.svg`,
      description: "Featured Products & Discounted prices",
    },
  ];

  const handleViewDetail = (cate: MenuItem) => {
    if (!cate.href) return;
    window.location.href = cate.href;
  };

  return (
    <div className={styles["comp-quick-menu"]}>
      <div className={styles["quick-menu-list"]}>
        {MenuList.map((cate: MenuItem) => (
          <div 
            key={cate.title}
            className={styles["quick-menu-item"]} 
            onClick={() => handleViewDetail(cate)}
          >
            <Image
              className={styles["quick-menu-icon"]}
              src={cate.image}
              alt={cate.title}
              width={42}
              height={42}
              priority={true}
            />

            <div className={styles["item-content"]}>
              <div className={styles["content-info"]}>
                <div className={styles["quick-menu-name"]}>{cate.title}</div>
                <div className={styles["quick-menu-desc"]}>{cate.description}</div>
              </div>
              <Arrow className={styles["arrow-icon"]} fontSize={"20px"} />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
